module.exports = __webpack_public_path__ + "fonts/Cairo-ExtraLight.b06831a6.ttf";